<!-- 相册上传 -->
<template>
  <div class="album-wrapper">
    <Card :padding="padding">
      <div slot="title" class="album-title box">相册</div>
      <div slot="extra" class="button_upload">
        上传
        <input
          type="file"
          id="uploads"
          class="input-file"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          multiple="multiple"
          @change="uploadImg"
          ref="imgs"
        >
      </div>
      <div class="pic-wrapper" @scroll="imgScrolls()" ref="picture">
        <Spin fix v-if="spinShow"></Spin>
        <upload-img
          :imgArr="imgArr"
          :imgNumber="imgNumber"
          :isClick="isClick"
          :isClickE="isClickE"
          @saveImg="saveImg"
          @cancelUpload="cancelUpload"
          @delPic="delPic"
        ></upload-img>
      </div>
    </Card>
  </div>
</template>

<script>
var that;
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import uploadImg from "../../../components/uplImgAct";
import { constants } from 'crypto';
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    id: null
  },
  components: {
    uploadImg
  },
  data() {
    //这里存放数据
    return {
      padding: 0,
      imgNumber: 9, //图片最多传几张
      imgArr: [],
      filename: "", //存储选上传时择文件的文件名
      option: {
        img: ""
      },
      spinShow: false,
      isClick: 0,
      isClickE: "",
      newRule: 0,
      page: 1,
      rows: 30,
      isAllImage: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: { 
    uploadImg(e) {
      console.log(e)
      this.isClickE = e;
      this.isClick++;
    },
    // 保存图片上传
    // 日期：2019年4月12日 目前一次就一个图片 所有id可用 toString() 后期改动时一起改
    saveImg(item) {
      var url = that.urlobj.saveActivityPic;
      console.log(item)
      this.$post(url, {
        activityId: parseInt(that.id),
        picIds: item.id.toString()
      }).then(res => {
        if (res.isSucceed) {
          that.imgArr = [];
          that.page = 1;
          that.getPic();
        }
      });
      this.$refs.imgs.value = ""; // value 必须置空 不然对同一个文件不会触发 onchange 事件
    },
    // 取消图片上传
    cancelUpload() {
      this.$refs.imgs.value = ""; // value 必须置空 不然对同一个文件不会触发 onchange 事件
    },
    // 删除图片
    delPic(communityEntity) {
      var url = that.urlobj.delActivityPic;
      this.spinShow = true;
      that
        .$post(url, {
          activityId: that.id, // 活动id
          id: communityEntity.id // 图片活动主键id
        })
        .then(res => {
          this.spinShow = false;
          this.$Message.success("删除成功");
          that.imgArr = [];
          that.page = 1;
          that.getPic();
        })
        .catch(() => {
          this.spinShow = false;
        });
    },
    // 滚动加载
    imgScrolls() {
      if (!that.isAllImage) {
        var offsetHeight = that.$refs.picture.offsetHeight,
          scrollHeight = that.$refs.picture.scrollHeight,
          scrollTop = that.$refs.picture.scrollTop,
          scrollBottom = offsetHeight + scrollTop;
        if (scrollBottom == scrollHeight) {
          that.page++;
          that.getPic();
        }
      }
    },
    // 获取图片列表
    getPic() {
      this.spinShow = true;
      that
        .$post(that.urlobj.getActivityPicList, {
          id: that.id, // 活动id
          pageNum: that.page,
          pageSize: that.rows
        })
        .then(res => {
          this.spinShow = false;
          if (res.rows.length < that.rows) {
            that.isAllImage = true;
          }
          that.imgArr =  res.rows.map(item => {
              return {
                id: item.id, // 附件与活动对应主键id
                fileId: item.fileId, // 附件id
                path: item.filePath,
                isHeight: 1
              };
            })
        });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    that = this;
    that.getPic();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.album-wrapper {
  width: 100%;
}
.album-title {
  height: 28px;
  line-height: 28px;
}
.button_upload {
  position: relative;
  background-color: #ff7b43;
  border: 1px solid #ff7b43;
  border-radius: 4px;
  color: #fff;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  padding: 0 16px;
  cursor: pointer;
}
.input-file {
  position: absolute;
  opacity: 0;
  right: 0px;
  top: 0;
  height: 100%;
  width: 60px;
  cursor: pointer;
}
.pic-wrapper {
  position: relative;
  height: 210px;
  padding: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.pic-wrapper::-webkit-scrollbar {
  width: 0;
}
</style>
